import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const ActionButton = ({ record, onViewDetail, onChat }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
    	event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
    	event.stopPropagation();
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={(e) => handleClick(e)}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={(e) => handleClose(e)}
            >
                <MenuItem onClick={(e) => { onViewDetail(record); handleClose(e); }}>View Details</MenuItem>
                <MenuItem onClick={(e) => { onChat(record); handleClose(e); }}>Chat</MenuItem>
            </Menu>
        </>
    );
};
export default ActionButton;